import React from 'react';
import { Tabs } from 'antd';
import { UserOutlined, SettingOutlined, HistoryOutlined, KeyOutlined, LinkOutlined } from '@ant-design/icons';
import UsersManager from '../components/admin/UsersManager';
import ActivityLogsTab from '../components/admin/ActivityLogsTab';
import PermissionsManager from '../components/admin/PermissionsManager';
import NotificationSettings from '../components/admin/NotificationSettings';
import AccountMappings from '../components/admin/AccountMappings';

const AdminPage = () => {
    const items = [
        {
            key: 'users',
            label: (
                <span>
                    <UserOutlined />
                    Users
                </span>
            ),
            children: <UsersManager />,
        },
        {
            key: 'permissions',
            label: (
                <span>
                    <KeyOutlined />
                    Permissions
                </span>
            ),
            children: <PermissionsManager />,
        },
        {
            key: 'activity',
            label: (
                <span>
                    <HistoryOutlined />
                    Activity Logs
                </span>
            ),
            children: <ActivityLogsTab />,
        },
        {
            key: 'settings',
            label: (
                <span>
                    <SettingOutlined />
                    System Settings
                </span>
            ),
            children: <NotificationSettings />,
        },
        {
            key: 'account-mappings',
            label: (
                <span>
                    <LinkOutlined />
                    Account Mappings
                </span>
            ),
            children: <AccountMappings />,
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <h1>Admin Panel</h1>
            <Tabs defaultActiveKey="users" items={items} />
        </div>
    );
};

export default AdminPage;



